import type { Provider } from '@angular/core';
import { provideHlmToastDefaultTimeout, type ToastService } from './toast.service';

/** Тост в продукте читают, отрываясь от кадра в руке: секунда сверх общего дефолта либы. */
export const PRODUCT_TOAST_TIMEOUT_MS = 5000;

/** Один дом для продуктовых 5 с: фотокласс, кабинет галерей и публичная галерея зовут его, а не свой провайдер. */
export function provideProductToasts(): Provider {
  return provideHlmToastDefaultTimeout(PRODUCT_TOAST_TIMEOUT_MS);
}

export const OWNER_PREVIEW_WRITE_REFUSED = 'В предпросмотре изменения не сохраняются';
/** One refusal for every write the owner preview swallows (editor approve, client likes/archive/«не я»); 5 s like any refused edit. */
export function toastOwnerPreviewRefusal(toast: Pick<ToastService, 'show'>): void {
  toast.show(OWNER_PREVIEW_WRITE_REFUSED, 'info', PRODUCT_TOAST_TIMEOUT_MS);
}
